import { render, staticRenderFns } from "./DPCreateTemplate.vue?vue&type=template&id=15429d43&scoped=true&"
import script from "./DPCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./DPCreateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DPCreateTemplate.vue?vue&type=style&index=0&id=15429d43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15429d43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15429d43')) {
      api.createRecord('15429d43', component.options)
    } else {
      api.reload('15429d43', component.options)
    }
    module.hot.accept("./DPCreateTemplate.vue?vue&type=template&id=15429d43&scoped=true&", function () {
      api.rerender('15429d43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/DPCreateTemplate.vue"
export default component.exports